var _style, _circle, _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipse5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#82DECF;}\n\t.st1{clip-path:url(#SVGID_00000159432820465124349880000017603526999698312890_);}\n\t.st2{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    transform: "translate(2806 -850) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    transform: "matrix(0, -1, 1, 0, 850, 2806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 10.6,
    y: 11.9,
    width: 19.7,
    height: 15.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085213520606834828100000014044036757014835869_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    style: {
      clipPath: "url(#SVGID_00000085213520606834828100000014044036757014835869_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    className: "st2",
    d: "M30,18.7l-5.5-6.4c-0.4-0.5-1.2-0.6-1.7-0.1l0,0c-0.5,0.4-0.5,1.2-0.1,1.7l3.8,4.4H11.8 c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2h14.8l-3.8,4.4c-0.4,0.5-0.3,1.2,0.1,1.7c0.5,0.4,1.2,0.4,1.7-0.1l5.5-6.4 C30.4,19.8,30.4,19.2,30,18.7L30,18.7z"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    className: "st2",
    d: "M876.8,2783.2c-0.5,0.5-1.2,0.5-1.7,0.1l-4.4-3.8v14.8c0,0.7-0.5,1.2-1.2,1.2 s-1.2-0.5-1.2-1.2v-14.8l-4.4,3.8c-0.5,0.4-1.2,0.4-1.7-0.1c-0.4-0.5-0.4-1.2,0.1-1.7l0,0l6.4-5.5c0.2-0.2,0.5-0.3,0.8-0.3 s0.6,0.1,0.8,0.3l6.4,5.5c0.3,0.2,0.4,0.6,0.4,0.9C877.1,2782.7,877,2782.9,876.8,2783.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse5);
export default __webpack_public_path__ + "static/media/Ellipse 5.4cec97f51b80fed7dcf409207ec682a4.svg";
export { ForwardRef as ReactComponent };